import { gql } from '@apollo/client';

import { groupFragment } from '../fragments';

export default gql`
  mutation UpdateGroup(
    $courseId: String!
    $groupId: String!
    $input: UpdateGroupInput!
  ) {
    group(courseId: $courseId, groupId: $groupId, input: $input)
      @rest(
        type: "Group"
        path: "courses/{args.courseId}/groups/{args.groupId}"
        method: "PUT"
      ) {
      ...Group
    }
  }
  ${groupFragment}
`;
